<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">代付平台:</span>
            <Select
              v-model="table.params.id"
              filterable
              placeholder="输入平台ID或名称筛选代付平台"
              clearable
            >
              <Option
                v-for="(item, index) in select.pay_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">使用状态:</span>
            <Select
              v-model="table.params.use"
              placeholder="选择使用状态"
              clearable
            >
              <Option
                v-for="(item, index) in select.use_list"
                :value="item.value"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="7" style="display: flex; justify-content: space-between">
          <Button type="primary" @click.native="GetProxyPayPlatformList()"
            >查询</Button
          >
          <Button type="primary" @click.native="addNewPlatform()"
            >新增代付平台</Button
          >
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      @on-selection-change="selectTable"
      style="margin-top: 12px"
    ></Table>
    <Page
      v-show="table.data.length"
      show-sizer
      show-total
      style="margin-top: 10px"
      :total="table.total"
      :current="table.params.page"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.limit"
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>
    <Row :gutter="16" style="margin-top: 12px">
      <Col span="20">
        <Button
          type="error"
          :disabled="this.table.sel_ids.length == 0"
          @click="moreDelete"
          >批量删除</Button
        >
      </Col>
    </Row>

    <!-- //新增、编辑代付平台 -->
    <Modal v-model="Channel_Modal.show" width="500">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>{{ Channel_Modal.data.id ? "编辑" : "新增" }}代付平台</span>
      </p>
      <div style="text-align: center">
        <Form
          :labelWidth="150"
          :rules="Channel_Modal.rules"
          :ref="Channel_Modal.ref"
          :model="Channel_Modal.data"
        >
          <Form-item label="平台状态:">
            <RadioGroup
              v-model="Channel_Modal.data.status"
              style="display: flex"
            >
              <Radio :label="1">启用</Radio>
              <Radio :label="2">禁用</Radio>
            </RadioGroup>
          </Form-item>
          <FormItem
            label="代付平台ID:"
            style="text-align: left"
            v-show="!!Channel_Modal.data.id"
          >
            <Input
              v-model="Channel_Modal.data.id"
              placeholder="请配置代付平台ID"
              style="width: 250px"
              :disabled="true"
            ></Input>
          </FormItem>
          <FormItem label="代付平台名称:" prop="name" style="text-align: left">
            <Input
              v-model="Channel_Modal.data.name"
              placeholder="请配置代付平台名称"
              style="width: 250px"
            ></Input>
          </FormItem>
          <FormItem label="平台备注信息:" style="text-align: left">
            <Input
              type="textarea"
              v-model="Channel_Modal.data.remark"
              placeholder="请配置代付平台备注信息"
              style="width: 250px"
              :rows="4"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="warning" @click.native="closeChannelModal()">取消</Button>
        <Button type="success" @click.native="addOrUpdatePlatform()"
          >确认修改</Button
        >
      </div>
    </Modal>
    <!-- 参数配置 -->
    <Modal v-model="modelUser.show" width="1000">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>平台参数配置</span>
      </p>
      <!-- <div style="max-height:600px;overflow:auto"> -->
      <div style="max-height: 650px">
        <Tabs v-model="modelUser.form.value">
          <TabPane label="基础配置" name="name1">
            <div
              style="
                background: #eee;
                padding: 20px;
                max-height: 600px;
                overflow: auto;
              "
            >
              <Form
                :ref="modelUser.form.ref"
                :model="modelUser.form.params"
                label-position="top"
              >
                <Collapse v-model="modelUser.form.collapse">
                  <Panel name="1">
                    基础设置
                    <div slot="content">
                      <Row :gutter="20">
                        <Col span="8">
                          <FormItem label="支付模板id:">
                            <InputNumber
                              v-model="modelUser.form.params.pay_id"
                              style="width: 100%"
                              placeholder="输入支付模板id"
                            ></InputNumber>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="平台名称:">
                            <Input
                              v-model="modelUser.form.params.name"
                              placeholder="平台名称"
                            ></Input>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="平台状态:">
                            <Select
                              v-model="Channel_Modal.data.status"
                              placeholder="请选择平台状态"
                              clearable
                            >
                              <Option
                                v-for="(item, index) in 2"
                                :value="item"
                                :key="index"
                                >{{ item == 1 ? "启用" : "禁用" }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="支付接口地址:">
                            <Input
                              v-model="modelUser.form.params.url"
                              placeholder="输入支付接口地址"
                              clearable
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="代理类型:">
                            <Select
                              v-model="modelUser.form.params.with_proxy"
                              placeholder="代理类型"
                              clearable
                            >
                              <Option
                                v-for="item in select.with_proxy_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem
                            label="指定回调白名单ip（多个请用逗号分隔）:"
                          >
                            <Input
                              v-model="modelUser.form.params.mast_ip"
                              placeholder="指定回调ip,逗号分隔"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="是否支持 https:">
                            <Select
                              v-model="modelUser.form.params.support_https"
                              placeholder="是否支持 https"
                              clearable
                            >
                              <Option
                                v-for="item in select.support_https_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                      </Row>
                    </div>
                  </Panel>
                  <Panel name="2">
                    请求设置
                    <div slot="content">
                      <Row :gutter="20">
                        <Col span="8">
                          <FormItem label="下单接口:">
                            <Input
                              v-model="modelUser.form.params.create_api"
                              placeholder="下单接口"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="金额单位:">
                            <Select
                              v-model="modelUser.form.params.price_unit"
                              placeholder="金额单位"
                              clearable
                            >
                              <Option
                                v-for="item in select.price_unit_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="发起请求类型:">
                            <Select
                              v-model="modelUser.form.params.req_type"
                              placeholder="发起请求类型"
                              clearable
                            >
                              <Option
                                v-for="item in select.req_type_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="请求时不参与签名字段:">
                            <Input
                              v-model="modelUser.form.params.no_req_sign_field"
                              placeholder="多个字段用逗号分隔"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem
                            label="指定请求时签名字段（多个请用逗号分隔）:"
                          >
                            <Input
                              v-model="modelUser.form.params.req_sign_field"
                              placeholder="请按照顺序输入,并逗号分隔"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="字段连接符:">
                            <Input
                              v-model="modelUser.form.params.join"
                              placeholder="&"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="签名key:">
                            <Input
                              v-model="modelUser.form.params.sign_key"
                              placeholder="&key="
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="签名key类型:">
                            <Select
                              v-model="modelUser.form.params.key_type"
                              placeholder="签名key类型"
                              clearable
                            >
                              <Option
                                v-for="item in select.Key_type_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="签名字符串是否需要字段名:">
                            <Select
                              v-model="modelUser.form.params.with_field"
                              placeholder="是否需要字段名"
                              clearable
                            >
                              <Option
                                v-for="item in select.need_filed_name_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="请求字段名连接符:">
                            <Input
                              v-model="modelUser.form.params.join_field_name"
                              placeholder="="
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="签名类型:">
                            <Select
                              v-model="modelUser.form.params.sign_type"
                              placeholder="签名类型"
                              clearable
                            >
                              <Option
                                v-for="item in select.sign_type_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="请求时空值参与签名:">
                            <Select
                              v-model="
                                modelUser.form.params.sign_include_nil_filed
                              "
                              placeholder="创建订单当指定字段参与签名时是否剔除值为空的字段"
                            >
                              <Option
                                v-for="item in select.support_https_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="请求时密钥名不参与签名:">
                            <Select
                              v-model="
                                modelUser.form.params.sign_exclude_key_name
                              "
                              placeholder="创建订单当指定字段参与签名时密钥的名字是否不参与签名"
                            >
                              <Option
                                v-for="item in select.support_https_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="请求时密钥位置:">
                            <Select
                              v-model="modelUser.form.params.sign_key_pos_type"
                              placeholder="密钥位置"
                              clearable
                            >
                              <Option
                                v-for="item in select.keyList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                      </Row>
                    </div>
                  </Panel>
                  <Panel name="3">
                    查询设置
                    <div slot="content">
                      <Row :gutter="20">
                        <Col span="8">
                          <FormItem label="查询接口:">
                            <Input
                              v-model="modelUser.form.params.query_api"
                              placeholder="查询接口"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询发起请求类型:">
                            <Select
                              v-model="modelUser.form.params.query_req_type"
                              placeholder="查询发起请求类型"
                              clearable
                            >
                              <Option
                                v-for="item in select.req_type_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询时不参与签名字段:">
                            <Input
                              v-model="
                                modelUser.form.params.query_no_req_sign_field
                              "
                              placeholder="查询时不参与签名字段"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="指定查询时签名字段:">
                            <Input
                              v-model="
                                modelUser.form.params.query_req_sign_field
                              "
                              placeholder="请按照顺序输入,并逗号分隔"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询签名key:">
                            <Input
                              v-model="modelUser.form.params.query_sign_key"
                              placeholder="&key="
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询签名key类型:">
                            <Select
                              v-model="modelUser.form.params.query_key_type"
                              placeholder="查询签名key类型"
                              clearable
                            >
                              <Option
                                v-for="item in select.Key_type_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询字段连接符:">
                            <Input
                              v-model="modelUser.form.params.query_join"
                              placeholder="&"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询是否需要字段名:">
                            <Select
                              v-model="modelUser.form.params.query_with_field"
                              placeholder="查询是否需要字段名"
                              clearable
                            >
                              <Option
                                v-for="item in select.need_filed_name_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询字段名连接符:">
                            <Input
                              v-model="
                                modelUser.form.params.query_join_field_name
                              "
                              placeholder="="
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询签名类型:">
                            <Select
                              v-model="modelUser.form.params.query_sign_type"
                              placeholder="查询签名类型"
                              clearable
                            >
                              <Option
                                v-for="item in select.sign_type_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询时空值参与签名:">
                            <Select
                              v-model="
                                modelUser.form.params
                                  .query_sign_include_nil_filed
                              "
                              placeholder="创建订单当指定字段参与签名时是否剔除值为空的字段"
                            >
                              <Option
                                v-for="item in select.support_https_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询时密钥名不参与签名:">
                            <Select
                              v-model="
                                modelUser.form.params
                                  .query_sign_exclude_key_name
                              "
                              placeholder="创建订单当指定字段参与签名时密钥的名字是否不参与签名"
                            >
                              <Option
                                v-for="item in select.support_https_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="查询时密钥位置:">
                            <Select
                              v-model="
                                modelUser.form.params.query_sign_key_pos_type
                              "
                              placeholder="密钥位置"
                              clearable
                            >
                              <Option
                                v-for="item in select.keyList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                      </Row>
                    </div>
                  </Panel>
                  <Panel name="4">
                    回调设置
                    <div slot="content">
                      <Row :gutter="20">
                        <Col span="8">
                          <FormItem label="回调金额单位:">
                            <Select
                              v-model="modelUser.form.params.nti_price_unit"
                              placeholder="回调金额单位"
                              clearable
                            >
                              <Option
                                v-for="item in select.price_unit_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时签名key:">
                            <Input
                              v-model="modelUser.form.params.nti_sign_key"
                              placeholder="&key="
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时字段连接符:">
                            <Input
                              v-model="modelUser.form.params.nti_join"
                              placeholder="&"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时签名字符串是否需要字段名:">
                            <Select
                              v-model="modelUser.form.params.nti_with_field"
                              placeholder="是否需要字段名"
                              clearable
                            >
                              <Option
                                v-for="item in select.need_filed_name_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时字段名连接符:">
                            <Input
                              v-model="
                                modelUser.form.params.nti_join_field_name
                              "
                              placeholder="="
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时签名key类型:">
                            <Select
                              v-model="modelUser.form.params.nti_key_type"
                              placeholder="签名key类型"
                              clearable
                            >
                              <Option
                                v-for="item in select.Key_type_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时签名类型:">
                            <Select
                              v-model="modelUser.form.params.nti_sign_type"
                              placeholder="签名类型"
                              clearable
                            >
                              <Option
                                v-for="item in select.sign_type_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调成功响应字符串:">
                            <Input
                              v-model="modelUser.form.params.success_str"
                              placeholder="输入回调响应字符串"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时不参与签名字段:">
                            <Input
                              v-model="modelUser.form.params.no_nti_sign_field"
                              placeholder="多个用逗号分隔"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem
                            label="指定回调时签名字段（多个请用逗号分隔）:"
                          >
                            <Input
                              v-model="modelUser.form.params.nti_sign_field"
                              placeholder="请按照顺序输入,并逗号分隔"
                            />
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调成功是否需要查询:">
                            <Select
                              v-model="modelUser.form.params.need_query"
                              placeholder="回调成功是否需要查询"
                              clearable
                            >
                              <Option
                                v-for="item in select.support_https_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时空值参与签名:">
                            <Select
                              v-model="
                                modelUser.form.params.nti_sign_include_nil_filed
                              "
                              placeholder="创建订单当指定字段参与签名时是否剔除值为空的字段"
                            >
                              <Option
                                v-for="item in select.support_https_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时密钥名不参与签名:">
                            <Select
                              v-model="
                                modelUser.form.params.nti_sign_exclude_key_name
                              "
                              placeholder="创建订单当指定字段参与签名时密钥的名字是否不参与签名"
                            >
                              <Option
                                v-for="item in select.support_https_List"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="回调时密钥位置:">
                            <Select
                              v-model="
                                modelUser.form.params.nti_sign_key_pos_type
                              "
                              placeholder="密钥位置"
                              clearable
                            >
                              <Option
                                v-for="item in select.keyList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                      </Row>
                    </div>
                  </Panel>
                  <Panel name="5">
                    json字符串
                    <div slot="content">
                      <Row :gutter="20">
                        <Col span="20">
                          <FormItem>
                            <Input
                              type="textarea"
                              :autosize="{ minRows: 15 }"
                              v-model="modelUser.form.params1"
                            />
                          </FormItem>
                        </Col>
                      </Row>
                    </div>
                  </Panel>
                </Collapse>
              </Form>
            </div>
          </TabPane>
          <!-- v-if="modelUser.form.params.config_id" -->
          <TabPane label="参数配置" name="name2">
            <div
              style="
                background: #eee;
                padding: 20px;
                max-height: 600px;
                overflow: auto;
              "
            >
              <Collapse v-model="modelUser.form2.collapse">
                <Panel name="1">
                  请求参数
                  <div slot="content">
                    <Button
                      style="margin: 10px"
                      type="primary"
                      @click="mapAdd(1)"
                      >新增</Button
                    >
                    <Table
                      border
                      :columns="modelUser.form2.columnsReq"
                      :data="modelUser.form2.params.req_filed_map"
                    />
                  </div>
                </Panel>
                <Panel name="2">
                  响应参数
                  <div slot="content">
                    <Button
                      style="margin: 10px"
                      type="primary"
                      @click="mapAdd(2)"
                      >新增</Button
                    >
                    <Table
                      border
                      :columns="modelUser.form2.columnsRsp"
                      :data="modelUser.form2.params.rsp_filed_map"
                    />
                  </div>
                </Panel>
                <Panel name="3">
                  回调参数
                  <div slot="content">
                    <Button
                      style="margin: 10px"
                      type="primary"
                      @click="mapAdd(0)"
                      >新增</Button
                    >
                    <Table
                      border
                      :columns="modelUser.form2.columnsNti"
                      :data="modelUser.form2.params.nti_filed_map"
                    />
                  </div>
                </Panel>
                <Panel name="4">
                  查询请求参数
                  <div slot="content">
                    <Button
                      style="margin: 10px"
                      type="primary"
                      @click="mapAdd(3)"
                      >新增</Button
                    >
                    <Table
                      border
                      :columns="modelUser.form2.columnQueryReq"
                      :data="modelUser.form2.params.query_req_filed_map"
                    />
                  </div>
                </Panel>
                <Panel name="5">
                  查询响应参数
                  <div slot="content">
                    <Button
                      style="margin: 10px"
                      type="primary"
                      @click="mapAdd(4)"
                      >新增</Button
                    >
                    <Table
                      border
                      :columns="modelUser.form2.columnQueryRep"
                      :data="modelUser.form2.params.query_rsp_filed_map"
                    />
                  </div>
                </Panel>
                <Panel name="6">
                  json字符串
                  <div slot="content">
                    <Input
                      type="textarea"
                      :autosize="{ minRows: 15 }"
                      v-model="modelUser.form2.params1"
                    />
                  </div>
                </Panel>
              </Collapse>
            </div>
          </TabPane>
          <TabPane label="银行编码映射" name="name3">
            <div
              style="
                background: #eee;
                padding: 20px;
                max-height: 600px;
                overflow: auto;
              "
            >
              <Collapse v-model="modelUser.form3.collapse">
                <Panel name="1">
                  银行编码映射
                  <div slot="content">
                    <Input
                      type="textarea"
                      :autosize="{ minRows: 10 }"
                      v-model="modelUser.form3.params.bank_code_map"
                    />
                  </div>
                </Panel>
              </Collapse>
            </div>
          </TabPane>
        </Tabs>
      </div>
      <!-- </div> -->
      <div slot="footer">
        <Button type="success" @click.native="updateModelUser()">确定</Button>
        <Button type="warning" @click.native="modelUser.show = false"
          >取消</Button
        >
      </div>
    </Modal>
    <Modal v-model="modelCopy.show" width="500">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>复制平台</span>
      </p>
      <div style="text-align: center">
        <Form
          :labelWidth="150"
          :rules="modelCopy.rules"
          :ref="modelCopy.ref"
          :model="modelCopy.param"
        >
          <FormItem label="代付平台名称:" prop="name" style="text-align: left">
            <Input
              v-model="modelCopy.param.name"
              placeholder="请配置新平台名称"
              style="width: 250px"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="warning" @click.native="closeCopy">取消</Button>
        <Button type="success" @click.native="toCopy">确定复制</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  GetAllProxyPayPlatform,
  GetProxyPayPlatformList,
  SaveProxyPayPlatform,
  DelProxyPayPlatform,
  SaveProxyPayPlatformConfig,
  SaveProxyPayPlatformFieldMap,
  CopyProxyPayPlatform,
  SaveProxyPayPlatformBankCodeMap,
} from "@/api/admin/newpayment";
import { GetToken } from "../../libs/util";
import moment from "moment";
export default {
  name: "GlobalPayForConfig",
  data() {
    return {
      SysConstType: {},
      fieldList: [
        "nti_filed_map",
        "req_filed_map",
        "rsp_filed_map",
        "query_req_filed_map",
        "query_rsp_filed_map",
      ],
      select: {
        pay_list: [], //平台列表
        dataTime: [
          this.getCurrentZeroDay(),
          new Date(new Date().setHours(23, 59, 59, 59)),
        ],
        sign_type_List: [], //签名类型
        price_unit_List: [
          //金额单位
          { value: 1, name: "分" },
          { value: 2, name: "元" },
        ],
        with_proxy_List: [], //代理使用情况
        url_type_List: [], //接口地址拼接类型
        support_https_List: [
          { value: 1, name: "是" },
          { value: 2, name: "否" },
        ],
        keyList: [
          { value: 1, name: "密钥在最前端,使用通用连接符连接字符串" },
          { value: 2, name: "密钥在最前端,不使用连接符直接连接字符串" },
          { value: 3, name: "密钥在最后端,使用通用连接符连接字符串" },
          { value: 4, name: "密钥在最后端,不使用连接符直接连接字符串" },
        ],
        req_type_List: [], //请求类型
        Key_type_List: [], //签名密钥类型
        need_filed_name_List: [], //签名字符串是否需要字段名
        req_filed_List: [], /// 配置请求字段映射时，应用内字段
        rsp_filed_List: [], //// 配置响应字段映射时，应用内字段
        nti_filed_List: [], //// 配置通知字段映射时，应用内字段
        filed_type_List: [], // 配置字段映射时，字段类型选择
        query_req_filed_List: [], //配置查询请求字段映射时，应用内字段
        query_rsp_filed_List: [], //配置查询响应字段映射时，应用内字段
        pay_type_List: [], // 支付类型
        money_type_List: [], //金额类型
        use_list: [
          { value: 0, name: "全部" },
          { value: 1, name: "未使用" },
        ],
      },

      table: {
        sel_ids: [],
        params: {
          page: 1,
          limit: 10,
          id: null, // 平台id
          sort: "-create_time", // 排序
          use: null,
        },
        data: [],
        columns: [
          { type: "selection", align: "center", width: 50 },
          {
            key: "id",
            align: "center",
            minWidth: 70,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "代付平台ID",
                "显示该代付平台的ID，该ID为该代付平台的标识"
              ),
          },
          {
            key: "name",
            align: "center",
            minWidth: 70,
            renderHeader: (h, params) =>
              this.renderHeader(h, "代付平台名称", "显示该条代付平台的名称"),
          },
          {
            key: "status",
            align: "center",
            minWidth: 70,
            render: (h, params) =>
              h(
                "span",
                {
                  style: {
                    color: params.row.status == 1 ? "#19be6b" : "#ff9900",
                    fontWeight: 600,
                  },
                },
                params.row.status == 1 ? "启用" : "禁用"
              ),
            renderHeader: (h, params) =>
              this.renderHeader(h, "平台状态", "显示该条代付平台的状态"),
          },
          {
            key: "channel_count",
            align: "center",
            minWidth: 70,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "配置盘口数量",
                "显示配置该条代付平台盘口数量"
              ),
          },
          {
            key: "create_time",
            align: "center",
            minWidth: 70,
            render: (h, params) =>
              h(
                "span",
                moment(params.row.create_time * 1000)
                  .locale("zh-cn")
                  .format("YYYY-MM-DD")
              ),
            renderHeader: (h, params) =>
              this.renderHeader(h, "创建时间", "显示该代付平台的创建时间"),
          },
          {
            key: "",
            align: "center",
            minWidth: 450,
            fixed: "right",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: { type: "success" },
                    style: { margin: "2px", padding: "5px 20px" },
                    on: {
                      click: () => {
                        this.openCopy(params.row.id);
                      },
                    },
                  },
                  "复制"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                    },
                    style: { margin: "2px", padding: "5px 20px" },
                    on: {
                      click: () => {
                        this.$refs[this.Channel_Modal.ref].resetFields();
                        this.showChannelModal(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: { type: "primary" },
                    style: { margin: "2px", padding: "5px 20px" },
                    on: {
                      click: () => {
                        this.modelUser.form.id = params.row.id;
                        let result = { ...params.row };
                        result.mast_ip =
                          result.mast_ip == null
                            ? ""
                            : result.mast_ip.join(",");
                        result.sign_include_nil_filed =
                          result.sign_include_nil_filed || 2;
                        result.sign_exclude_key_name =
                          result.sign_exclude_key_name || 2;

                        result.query_sign_include_nil_filed =
                          result.query_sign_include_nil_filed || 2;
                        result.query_sign_exclude_key_name =
                          result.query_sign_exclude_key_name || 2;

                        result.nti_sign_include_nil_filed =
                          result.nti_sign_include_nil_filed || 2;
                        result.nti_sign_exclude_key_name =
                          result.nti_sign_exclude_key_name || 2;

                        this.modelUser.form.params = result;
                        this.modelUser.form.value = "name1";
                        this.fieldList.forEach((el) => {
                          let item = params.row[el];
                          this.modelUser.form2.params[el] = item
                            ? JSON.parse(item)
                            : [];
                        });
                        this.modelUser.form3.params = {
                          bank_code_map: params.row.bank_code_map,
                        };
                        this.modelUser.show = true;
                      },
                    },
                  },
                  "平台参数配置"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: params.row.status == 1 ? "warning" : "success",
                    },
                    style: { margin: "2px", padding: "5px 20px" },
                    on: {
                      click: () => {
                        this.Channel_Modal.data = {
                          id: params.row.id,
                          name: params.row.name,
                          remark: params.row.remark,
                          status: params.row.status == 1 ? 2 : 1,
                        };
                        this.SaveProxyPayPlatform();
                      },
                    },
                  },
                  params.row.status == 1 ? "禁用" : "启用"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                    },
                    style: {
                      margin: "2px",
                      padding: "5px 20px",
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "确认删除",
                          content: "<p>是否确认删除此条代付平台</p>",
                          onOk: () => {
                            this.DelProxyPayPlatform({
                              ids: [params.row.id],
                            });
                          },
                        });
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "管理",
                "管理【编辑】【启用/禁用】【平台参数配置】【删除】按钮"
              ),
          },
        ],
        total: 0,
        pageSizes: [10, 20, 30, 40],
      },
      modelCopy: {
        show: false,
        ref: "modelCopyRef",
        rules: {
          name: [
            {
              required: true,
              trigger: "blur",
              validator: this.simpleVerify("请输入配置代付平台名称"),
            },
          ],
        },
        param: { id: 0, name: "" },
      },
      modelUser: {
        show: false,
        type: false,
        form: {
          value: "name1",
          collapse: [1, 2, 3, 4],
          ref: "modelUser_form",
          id: 0,
          params1: {},
          params: {
            mast_ip: "",
            req_filed_map: "",
            rsp_filed_map: "",
            nti_filed_map: "",
            query_req_filed_map: "",
            query_rsp_filed_map: "",
          },
        },
        form2: {
          collapse: [1, 2, 3],
          ref: "modelUser_form2",
          params: {
            // 请求字段映射
            req_filed_map: [this.initMap()],
            // 响应字段映射
            rsp_filed_map: [this.initMap()],
            // 回调字段映射
            nti_filed_map: [this.initMap()],
            // 查询请求
            query_req_filed_map: [this.initMap()],
            // 查询回调
            query_rsp_filed_map: [this.initMap()],
          },
          params1: {},
          columnsReq: this.getParamTableColumn(
            "req_filed_map",
            "req_filed_List"
          ),
          columnsRsp: this.getParamTableColumn(
            "rsp_filed_map",
            "rsp_filed_List"
          ),
          columnsNti: this.getParamTableColumn(
            "nti_filed_map",
            "nti_filed_List"
          ),
          columnQueryReq: this.getParamTableColumn(
            "query_req_filed_map",
            "query_req_filed_List"
          ),
          columnQueryRep: this.getParamTableColumn(
            "query_rsp_filed_map",
            "query_rsp_filed_List"
          ),
        },
        form3: {
          value: "name3",
          collapse: [1],
          ref: "modelUser_form3",
          id: 0,
          params1: {},
          params: { bank_code_map: "" },
        },
      },
      Channel_Modal: {
        show: false,
        isAdd: false,
        ref: "ChannelModalValidate",
        data: { id: 0, name: "", status: 1, remark: "" },
        rules: {
          id: [
            {
              required: true,
              trigger: "blur",
              validator: this.simpleVerify("请输入配置代付平台ID"),
            },
          ],
          name: [
            {
              required: true,
              trigger: "blur",
              validator: this.simpleVerify("请输入配置代付平台名称"),
            },
          ],
        },
      },
    };
  },
  methods: {
    //选择表单
    selectTable(data) {
      this.table.sel_ids = [];
      data.map((item) => {
        this.table.sel_ids.push(item.id);
      });
    },
    //批量删除
    moreDelete() {
      this.$Modal.confirm({
        title: `确认批量删除【${this.table.sel_ids.length}】条代付平台数据？`,
        onOk: () => {
          DelProxyPayPlatform({ ids: this.table.sel_ids }).then((res) => {
            this.table.sel_ids = [];
            this.GetProxyPayPlatformList();
          });
        },
      });
    },
    modelUserParams() {
      let obj = this.copyData(this.modelUser.form.params);
      delete obj.id;
      this.modelUser.form.params1 = JSON.stringify(obj);
    },
    modelUser2Params() {
      this.modelUser.form2.params1 = JSON.stringify(
        this.modelUser.form2.params
      );
    },
    // 关闭复制窗口
    closeCopy() {
      this.modelCopy.show = false;
    },
    //打开复制窗口
    openCopy(id) {
      this.modelCopy.param.name = "";
      this.modelCopy.param.id = id;
      this.modelCopy.show = true;
    },
    initMap(app_field = "") {
      return { mch_field: "", app_field: app_field, type: "", default: "" };
    },
    //复制请求
    toCopy() {
      this.$refs[this.modelCopy.ref].validate(async (valid) => {
        if (valid) {
          CopyProxyPayPlatform({ ...this.modelCopy.param }).then((res) => {
            this.closeCopy();
            this.GetProxyPayPlatformList();
          });
        }
      });
    },
    //列表分页
    pagechange(page) {
      this.table.params.page = page;
      this.GetProxyPayPlatformList();
    },
    //列表分条
    limitchange(limit) {
      this.table.params.page = 1;
      this.table.params.limit = limit;
      this.GetProxyPayPlatformList();
    },
    //获取代付平台列表
    GetAllProxyPayPlatform() {
      GetAllProxyPayPlatform({}).then((res) => {
        this.select.pay_list = res._param || [];
      });
    },
    //获取数据
    GetProxyPayPlatformList() {
      let params = {
        ...this.table.params,
        use: this.table.params.use ? this.table.params.use : 0,
      };
      GetProxyPayPlatformList(params).then((res) => {
        this.table.total = res._param.total || 0;
        this.table.data = res._param.list || [];
        this.GetAllProxyPayPlatform();
      });
    },
    //关闭代付平台弹框
    closeChannelModal() {
      this.Channel_Modal.show = false;
    },
    //显示添加修改modal配置参数
    showChannelModal(params) {
      this.Channel_Modal.show = true;
      this.Channel_Modal.isAdd = !!params.id;
      this.Channel_Modal.data = {
        id: params.id,
        name: params.name,
        remark: params.remark,
        status: params.status,
      };
    },
    //新增代付平台弹出框
    addNewPlatform() {
      this.$refs[this.Channel_Modal.ref].resetFields();
      this.showChannelModal({ id: 0, name: "", remark: "", status: 1 });
    },
    //新增、修改代付平台操作流程
    async addOrUpdatePlatform() {
      this.$refs[this.Channel_Modal.ref].validate(async (valid) => {
        if (valid) {
          await SaveProxyPayPlatform(this.Channel_Modal.data);
          this.closeChannelModal();
          this.GetProxyPayPlatformList();
        }
      });
    },
    //保存代付平台
    async SaveProxyPayPlatform() {
      await SaveProxyPayPlatform(this.Channel_Modal.data);
      this.GetProxyPayPlatformList();
    },
    //删除平台支付id
    async DelProxyPayPlatform(params) {
      await DelProxyPayPlatform(params);
      this.GetProxyPayPlatformList();
    },
    //保存配置
    SaveProxyPayPlatformConfig() {
      SaveProxyPayPlatformConfig({});
    },
    getSysObj(value, type) {
      let name = this.SysConstType[type][value];
      value = Number(value);
      return { value, name };
    },
    //获取系统
    getSysConst() {
      this.SysConstType = GetToken().SysConstType;
      let arr = [
        "price_unit",
        "sign_type",
        "with_proxy",
        "url_type",
        "url_type",
        "req_type",
        "Key_type",
        "need_filed_name",
        "pay_type",
        "money_type",
      ];
      arr.forEach((el) => {
        let newValue = [];
        for (let i in this.SysConstType[el]) {
          newValue.push(this.getSysObj(i, el));
        }
        this.select[el + "_List"] = newValue;
      });

      // 配置请求字段映射时，应用内字段
      this.select.req_filed_List = this.SysConstType.proxy_req_filed;
      this.select.query_req_filed_List =
        this.SysConstType.proxy_query_req_filed || [];
      this.select.query_rsp_filed_List =
        this.SysConstType.proxy_query_rsp_filed || [];
      // 配置响应字段映射时，应用内字段
      this.select.rsp_filed_List = this.SysConstType.proxy_rsp_filed;
      // 配置通知字段映射时，应用内字段
      this.select.nti_filed_List = this.SysConstType.proxy_nti_filed;
      // 配置字段映射时，字段类型选择
      this.select.filed_type_List = this.SysConstType.filed_type;
    },
    mapAdd(index) {
      let type = this.fieldList[index];
      let app_field = index == 2 ? "mch_id" : "";
      this.modelUser.form2.params[type].push(this.initMap(app_field));
    },
    getFieldOption(h) {
      return this.select.filed_type_List.map((item, i) => {
        // this.productTypeList下拉框里的data
        return h("Option", {
          // 下拉框的值
          props: {
            value: item,
            label: item,
            key: i,
          },
        });
      });
    },
    getParamTableColumn(mapName, list) {
      return [
        {
          title: "商家ID",
          align: "center",
          key: "mch_field",
          render: (h, params) => {
            return h("Input", {
              props: {
                value:
                  this.modelUser.form2.params[mapName][params.index].mch_field,
                clearable: true,
              },
              on: {
                "on-blur": (num) => {
                  this.modelUser.form2.params[mapName][params.index].mch_field =
                    num.target.value;
                },
              },
            });
          },
        },
        {
          title: "应用",
          align: "center",
          key: "app_field",
          render: (h, params) => {
            return h(
              "Select",
              {
                props: {
                  value: params.row.app_field, // 获取选择的下拉框的值
                  clearable: true,
                },
                on: {
                  "on-change": (e) => {
                    this.modelUser.form2.params[mapName][
                      params.index
                    ].app_field = e;
                  },
                },
              },
              this.select[list].map((item, i) => {
                // this.productTypeList下拉框里的data
                return h("Option", {
                  // 下拉框的值
                  props: {
                    value: item,
                    label: item,
                    key: item,
                  },
                });
              })
            );
          },
        },
        {
          title: "类型",
          key: "type",
          align: "center",
          render: (h, params) => {
            return h(
              "Select",
              {
                props: {
                  value: params.row.type, // 获取选择的下拉框的值
                  clearable: true,
                },
                on: {
                  "on-change": (e) =>
                    (this.modelUser.form2.params[mapName][params.index].type =
                      e),
                },
              },
              this.getFieldOption(h)
            );
          },
        },
        {
          title: "默认参数",
          key: "default",
          align: "center",
          render: (h, params) => {
            return h("Input", {
              props: {
                value:
                  this.modelUser.form2.params[mapName][params.index].default,
                clearable: true,
              },
              on: {
                "on-blur": (num) => {
                  this.modelUser.form2.params[mapName][params.index].default =
                    num.target.value;
                },
              },
            });
          },
        },
        {
          align: "center",
          title: "操作",
          width: 80,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: { type: "error", size: "small" },
                  style: {
                    margin: "2px",
                  },
                  on: {
                    click: () => {
                      this.modelUser.form2.params[mapName].splice(
                        params.index,
                        1
                      );
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ];
    },
    //映射字段保存设置
    updateModelField(params, field) {
      params[field] = JSON.stringify(this.modelUser.form2.params[field]);
    },
    async updateModelUser() {
      let params = {
        id: this.modelUser.form.id,
        ...this.modelUser.form.params,
        mast_ip: this.modelUser.form.params.mast_ip.split(","),
      };
      this.updateModelField(params, "req_filed_map");
      this.updateModelField(params, "rsp_filed_map");
      this.updateModelField(params, "nti_filed_map");
      this.updateModelField(params, "query_req_filed_map");
      this.updateModelField(params, "query_rsp_filed_map");
      if (this.modelUser.form.value == "name1") {
        SaveProxyPayPlatformConfig(params).then((res) => {
          this.$Message.success("配置成功");
          this.GetProxyPayPlatformList();
        });
      } else if (this.modelUser.form.value == "name2") {
        SaveProxyPayPlatformFieldMap(params).then((res) => {
          this.$Message.success("配置成功");
          this.GetProxyPayPlatformList();
        });
      } else {
        let param = {
          id: this.modelUser.form.id,
          bank_code_map: this.modelUser.form3.params.bank_code_map,
        };
        SaveProxyPayPlatformBankCodeMap(param).then((res) => {
          this.$Message.success("配置成功");
          this.GetProxyPayPlatformList();
        });
      }
    },
  },
  watch: {
    "modelCopy.show": () => {
      this.$refs[this.modelCopy.ref].resetFields();
    },
    "modelUser.form.params": {
      immediate: true,
      deep: true,
      handler: function () {
        this.modelUserParams();
      },
    },
    "modelUser.form.params1": {
      immediate: true,
      deep: true,
      handler: function () {
        this.modelUser.form.params = JSON.parse(this.modelUser.form.params1);
      },
    },
    "modelUser.form2.params": {
      immediate: true,
      deep: true,
      handler: function () {
        this.modelUser2Params();
      },
    },
    "modelUser.form2.params1": {
      immediate: true,
      deep: true,
      handler: function () {
        this.modelUser.form2.params = JSON.parse(this.modelUser.form2.params1);
      },
    },
  },

  created() {
    this.getSysConst();
    this.GetProxyPayPlatformList();
  },
};
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
